import React from 'react';
import { Stack, Typography, Box } from '@mui/material';
import { MilitaryTech as MedalIcon } from '@mui/icons-material';

interface PosicionCellProps {
    posicion: number;
    // 'standard' = Oro, Plata, Bronce (Para Ranking Institucional)
    // 'gold-only' = Solo Oro (Para Unidades, Centros, Colaboración)
    // 'no-medal' = Sin medallas (Para Áreas/Subáreas de Profesores)
    variant?: 'standard' | 'gold-only' | 'no-medal'; 
}

export const PosicionCell: React.FC<PosicionCellProps> = ({ posicion, variant = 'standard' }) => {
    let showMedal = false;
    let medalColor = '';

    if (variant === 'standard') {
        // Lógica: 1, 2 y 3 tienen medalla
        if (posicion === 1) { showMedal = true; medalColor = '#FFD700'; } // Oro
        else if (posicion === 2) { showMedal = true; medalColor = '#C0C0C0'; } // Plata
        else if (posicion === 3) { showMedal = true; medalColor = '#CD7F32'; } // Bronce
    } 
    else if (variant === 'gold-only') {
        // Lógica: SOLO el 1 tiene medalla
        if (posicion === 1) { showMedal = true; medalColor = '#FFD700'; } 
    }
    // Si es 'no-medal', showMedal se queda en false siempre.

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start" // Alineado a la izquierda
            spacing={1} 
        >
            {/* Contenedor fijo para alinear la columna perfectamente */}
            <Box sx={{ width: 24, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {showMedal ? (
                    <MedalIcon sx={{ color: medalColor }} />
                ) : (
                    // Caja vacía invisible para mantener la alineación
                    <Box sx={{ width: 24, height: 24 }} /> 
                )}
            </Box>

            <Typography 
                variant="body1" 
                fontWeight="bold" 
                sx={{ textAlign: 'left', minWidth: '15px' }}
            >
                {posicion}
            </Typography>
        </Stack>
    );
};